/**
 * @generated SignedSource<<e35dfda094eee2b341d594af5a26a606>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
export type processDefinitionQueryResetMutation$variables = {
  id: string;
};
export type processDefinitionQueryResetMutation$data = {
  readonly resetProcessDefinition: {
    readonly definitionHash: string;
    readonly definitionKey: string;
    readonly definitionName: string;
    readonly definitionVersion: string | null | undefined;
    readonly definitionXml: string;
    readonly dirtyFlag: boolean;
    readonly id: string;
    readonly siteUrl: string;
    readonly status: Status;
  } | null | undefined;
};
export type processDefinitionQueryResetMutation = {
  response: processDefinitionQueryResetMutation$data;
  variables: processDefinitionQueryResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProcessDefinition",
    "kind": "LinkedField",
    "name": "resetProcessDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "definitionKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "definitionName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "definitionVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "definitionXml",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siteUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dirtyFlag",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "definitionHash",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQueryResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQueryResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5c239e801e0b6ada1d65fb4dbde1fc2",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQueryResetMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionQueryResetMutation(\n  $id: ID!\n) {\n  resetProcessDefinition(id: $id) {\n    definitionKey\n    definitionName\n    definitionVersion\n    definitionXml\n    id\n    siteUrl\n    status\n    dirtyFlag\n    definitionHash\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ba4af0561edc435d39071b20179c351";

export default node;
